import { render, staticRenderFns } from "./FoodIngredients.vue?vue&type=template&id=eedf60ba&"
import script from "./FoodIngredients.vue?vue&type=script&lang=js&"
export * from "./FoodIngredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports